const REMOVABLE_LAYER_IDS = [
	'waterway-label',
	'natural-line-label',
	'natural-point-label',
	'water-line-label',
	'water-point-label',
	'poi-label',
	'airport-label',
	'continent-label',
	'settlement-major-label',
	'settlement-minor-label',
	'settlement-subdivision-label',
	'road-label-simple'
];

export const removeLayers = ({ map, layers = REMOVABLE_LAYER_IDS }) => {
	map.style.stylesheet.layers.forEach(function (layer) {
		if (layers.includes(layer.id)) map.removeLayer(layer.id);
	});
};
